/** Account roles in the reader's words: «OWNER» is a code, not a name. */
const ROLE: Readonly<Record<string, string>> = {
  OWNER: "владелец",
  OPERATOR: "оператор",
  VIEWER: "наблюдатель",
};

export function roleNames(roles: readonly string[]): string {
  return roles.map((role) => ROLE[role] ?? role).join(", ");
}
